// src/theme.js
const theme = {
  colors: {
    background: "#121212",
    primary: "#1DB954",
    textPrimary: "#FFFFFF",
    textSecondary: "#B3B3B3",
  },
  fonts: {
    body: "Arial, sans-serif",
  },
};

export default theme;
